var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Favorite",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Favorite",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91 7.397L8.505 4.78 7.098 7.397l-2.891.49L6.249 9.95l-.424 2.896 2.68-1.294 2.68 1.294-.425-2.896 2.042-2.062-2.891-.491zm6.26-.964a.4.4 0 01.218.675l-3.503 3.539.717 4.893a.4.4 0 01-.57.417l-4.528-2.185-4.527 2.185a.4.4 0 01-.57-.417l.717-4.893L.62 7.107a.4.4 0 01.218-.674l4.959-.843 2.355-4.38a.4.4 0 01.705 0l2.355 4.381 4.959.843z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgReviewsIcon;